import { ProductType } from "@/utils/enums/ProductType"
import { useProductsStore } from "@/utils/stores/useProductsStore"
import { SubType } from "../types/SubType"

export const useMembership = () => {
    const { productsData } = useProductsStore()
    const membership = productsData.membership
    const dnaTest = productsData.dnaTest
    const hasMembership = membership !== undefined && membership !== null
    const hasDnaTest = (dnaTest !== null && dnaTest !== undefined)

    if (!hasMembership) return SubType.NONE
    else {
        switch (membership.sub_type) {
            case ProductType.SubHealth:
                if (hasDnaTest) return SubType.HEALTH_DNA
                else return SubType.HEALTH
            case ProductType.SubNutrition:
                return SubType.NUTRITION
            case ProductType.SubMetabolicHealth:
                return SubType.METABOLIC
            case ProductType.SubMetabolicHealthLite:
                return SubType.METABOLIC_LITE
            default:
                return SubType.OLD
        }
    }
}